import { type Middleware } from '@reduxjs/toolkit';
import { isRejected } from '@reduxjs/toolkit';
import { NotificationType } from 'types/enums';
import { AsyncThunkConfig } from 'types/types';
import { type store } from 'utils/store';
import { notificationActions } from 'utils/store/slice/notification';

const errorHandler: Middleware<AsyncThunkConfig, unknown, typeof store.instance.dispatch> = ({ dispatch }) => {
  return (next) => {
    return (action: ReturnType<typeof next>) => {
      if (isRejected(action) && !action.meta.rejectedWithValue) {
        const message = action.error.message ?? 'Server error';
        dispatch(
          notificationActions.notify({
            message,
            type: NotificationType.ERROR,
          }),
        );
      }

      return next(action);
    };
  };
};

export { errorHandler };
